module.exports = __webpack_public_path__ + "static/media/Eco Verde Estimating - Dashboard.1803b97a.jpg";